<template>

  <ModalContainer queryParam="finf" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <div>

        <h4 class="text-primary text-center mb-1">INFORME TECNICO</h4>

       <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success"
          active-tab-class="font-weight-bold text-success">
          <b-tab title="Datos Generales">
            <b-card>
              <b-row>
                <b-col cols="6">
                  <span>Fecha de elaboración:</span>
                  <flat-pickr v-model="informe.fechaElaboracion" placeholder="Seleccione la fecha"
                    class="form-control" />
                </b-col>
                   <b-col cols="6">
                  <span>Dirigido a:</span>
                  <b-form-textarea v-model="informe.dirigidoA"></b-form-textarea>
                </b-col>
                  <b-col cols="12" class="mt-1">
                  <span>Cuadro clinico y hallazgos relevantes de examenes y procedimientos diagnosticos:</span>
                  <b-form-textarea v-model="informe.cuadroClinico"></b-form-textarea>
                </b-col>
              
              </b-row>
              <hr/>
              <b-row>
                
                   <b-col cols="6">
                  <span>Fecha Atencion:</span>
                    <b-form-input disabled v-model="informe.fechaAtencion"></b-form-input>
                </b-col>
                <b-col cols="6">
                  <span>Codigo Validacion:</span>
                  <b-form-input disabled v-model="informe.codigoValidacion"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col cols="6">
                  <span>Especialidad donde se deriva:</span>
                  <b-form-input disabled v-model="informe.especialidadDeriva"></b-form-input>
                </b-col>
                 <b-col cols="6">
                  <span>Nivel donde se deriva:</span>
                  <b-form-input disabled v-model="informe.nivelDeriva"></b-form-input>
                </b-col>
                
               
              </b-row>
              <hr/>
              <span>Procedimiento realizado en la atencion</span>
              <b-row>
                
                
                  <SearchOpts v-model="searchProcedimiento" :searchService="procedimientosService.searchByQuery"
                    :minChars="3" :placeholder="'Buscar procedimiento...'" class="col-10" />
                    <b-col cols="2">
                      <b-button title="agregar procedimiento" variant="warning" @click="agregarProcedimiento" size="sm">
                        <i class="fa-solid fa-plus" />
                      </b-button>
                    </b-col>
                     <b-col v-if="informe.procedimientosList.length" class="mt-1" cols="12">
                      <b-table small :items="informe.procedimientosList" :fields="fieldsProcedimientos">
                     
                        <template #cell(acciones)="data">
                          <b-button @click="eliminarRegistroProcedimiento(data.index)" variant="danger" size="sm">
                            <i class="fa-solid fa-trash"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </b-col>
                
              </b-row>
            </b-card>
          </b-tab>
          <b-tab title="Diagnosticos/Conclusiones">
            <b-card>
              <b-row>
              
                <b-col cols="12" class="my-1">
                  <span>Diagnostico:</span>
                  <b-row class="d-flex align-items-center">

                    <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                      :minChars="3" :placeholder="'Buscar diagnostico...'" class="col-7" />
               
                    <b-col cols="2">
                      <b-button variant="warning" @click="agregarDiagnostico" size="sm">
                        <i class="fa-solid fa-plus" />
                      </b-button>
                    </b-col>

                    <b-col v-if="informe.diagnosticosList.length" class="mt-1" cols="12">
                      <b-table small :items="informe.diagnosticosList" :fields="fields">
                     
                        <template #cell(acciones)="data">
                          <b-button @click="eliminarRegistro(data.index)" variant="danger" size="sm">
                            <i class="fa-solid fa-trash"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <hr/>
                  <b-row>
                    <b-col>
                      <span>Observaciones:</span>
                      <b-form-textarea v-model="informe.observaciones"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr/>
                  <span >Medico Solicitante:</span>
                  <b-row>
                      
                      
                      <b-col>
                      <SearchOpts v-model="informe.medicoSolicitante" :searchService="doctoresService.searchDoctoresByTermSelect"
                      :minChars="3" :placeholder="'Buscar medico...'"/>
                      </b-col> 
                    
                  </b-row>

                </b-col>

               


              </b-row>

            </b-card>
          </b-tab>



        </b-tabs>
      </div>

      <div class="text-right">
        <b-button variant="primary" class="mr-2" @click="onSaveinforme">
          Guardar
        </b-button>

        <b-button>
          Cancelar
        </b-button>

      </div>
    </b-card>

  </ModalContainer>

</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService, procedimientosService } from "../../services";
import vSelect from "vue-select";



export default {
  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    VueTimepicker,
    vSelect
  },
   props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  data() {
    return {
      searchProcedimiento: null,
      searchMedico: null,
      tokenFormulario:null,

     
      idRegistroForm: null,
      selectedTipoDiagnostico: null,

      messageAlert: null,

      informe: {
        fechaElaboracion: null,
        dirigidoA: "SEÑORES DEPARTAMENTO DE DERIVACIONES SUBDIRECCION PROVINCIAL DE PRESTACIONES DE SALUD IESS GUAYAS",
        codigoValidacion: null,
        fechaAtencion: null,
        procedimientosList: [],
        diagnosticosList: [],
        medicoSolicitante: null,
        cuadroClinico: null,
        especialidadDeriva: null,
        observaciones: null,
        codigoTarifario: null,
        nivelDeriva: null,

      },



      searchDiagnostico: null,
      diagnosticosService,
      procedimientosService,
      idProcActual: null,
      doctoresService,

      doctor: null,

      fechaActual: null,
      horaActual: null,

      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },

      fields: [


        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsProcedimientos: [



        {
          key: "procedimiento",
          label: "Procedimiento",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

    };
  },
  created() {

    this.setDate();
    this.loadData();

    if (this.jsoForminforme) {
     this.informe = this.jsoForminforme
    }

  },

  methods: {


    async loadData() {
      this.informe = {

        fechaElaboracion: null,
        dirigidoA: "SEÑORES DEPARTAMENTO DE DERIVACIONES SUBDIRECCION PROVINCIAL DE PRESTACIONES DE SALUD IESS GUAYAS",
        codigoValidacion: null,
        fechaAtencion: null,
        procedimientosList: [],
        diagnosticosList: [],
        medicoSolicitante: null,
        cuadroClinico: null,
        especialidadDeriva: null,
        observaciones: null,
        codigoTarifario: null,
        nivelDeriva: null,


      },

        
      this.idRegistroForm = null;

      this.tokenProceso = this.$route.query.forms
      const tokenFormulario = this.$route.query.finf;

      const responseGet = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);

      console.log("response get", responseGet)



      if (responseGet) {
        this.messageAlert = {
          variant: "success",
          text: "Se encontró información registrada, se procederá a actualizar"
        }

      } else {
        this.messageAlert = {
          variant: "warning",
          text: "No se encontró informacion registrada"
        }

        const atencion = await procedimientosService.getDataAtencionByTokenProc(this.tokenProceso)

        if (atencion) {
          if (atencion.diagnosticos) {
          this.informe.diagnosticosList = atencion.diagnosticos
          }
          if (atencion.cuadroClinico) {
            this.informe.cuadroClinico = atencion.cuadroClinico
          }
          if (atencion.cita) {
            this.informe.fechaAtencion = atencion.cita.fechaCita
            this.informe.codigoValidacion = atencion.cita.codderivacion
          }
        

        }



        return;


      }

      let paciente = `${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.identificacion}-${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${responseGet.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

      const dataProceso = {
        paciente: paciente,
        codigo: responseGet.procedimientoCita.procedimiento.codigo,
        descripcion: responseGet.procedimientoCita.procedimiento.descripcion
      }

      try {
        const informe = JSON.parse(responseGet.dataJson)
        this.informe = informe
      } catch (error) { console.log("error", error) }


     
      this.idRegistroForm = responseGet.id;

    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


    eliminarRegistro(index) {
      this.informe.diagnosticosList.splice(index, 1);


    },
    eliminarRegistroProcedimiento(index) {
      this.informe.procedimientosList.splice(index, 1);

    },


    eliminarMedico(index) {
      this.informe.tableMedicos.splice(index, 1);
    },

    agregarProcedimiento(){
       if (!this.searchProcedimiento) {
        this.$swal.fire({
          icon: "info",
          text: "Ingrese el procedimiento",
        });
        return;
      }

      this.informe.procedimientosList.push({
        procedimiento: this.searchProcedimiento.text,
        procObject: this.searchProcedimiento,
       
      });

      this.searchProcedimiento = null;
     
    },


    agregarDiagnostico() {
     

      const dataTable = this.informe.diagnosticosList;

      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }

   

      this.informe.diagnosticosList.push({
        diagnostico: this.searchDiagnostico.text,
        diagObject: this.searchDiagnostico
      });

      this.searchDiagnostico = null;
    
    },


    async onSaveinforme() {

            const dataTable = this.informe.diagnosticosList;
      console.log("data table", dataTable)
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos"})
        return;
      }


      const params = {
        nameForm: "inf",
        dataJson: JSON.stringify(this.informe),
        tokenProceso: this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        idRegistroForm: this.idRegistroForm
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      }); 

    
      await this.$router.push({
        query: {
          ...this.$route.query,
          finf: undefined
        }
      });


      

      // await this.$router.push({ query: { ...this.$route.query, finf: undefined } });
      this.$emit("formulario-guardado");


   

    },
  },

  watch: {


    '$route.query.finf': {
      handler(newValue) {
        if (newValue) { this.loadData() }

      },
    },
  }

};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.parpadeo {
  font-weight: 200;
}
</style>
